import { makeStyles, createStyles } from '@mui/styles';

const privacyPageStyle = makeStyles(() =>
  createStyles({
    container: {
      width: '85%',
      margin: 'auto',
      marginTop: 150,
      color: '#073B70',
      '& p, & span, & li, & b, & a, & div': {
        color: '#073B70',
      },
      '& b': {
        display: 'inline',
        margin: 0,
        padding: 0,
      },
      '& p': {
        marginTop: 10,
        marginBottom: 0,
      },
      '& div': {
        marginTop: 6,
        marginBottom: 0,
      },
    },
    topic: {
      textAlign: 'center',
      fontWeight: 'bold',
    },
  })
);

export default privacyPageStyle;
